import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
	selector: "bp-pill",
	templateUrl: "./bp-pill.component.html",
	styleUrls: ["./bp-pill.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class BpPillComponent {
	@Input() public label: string;
	@Input() public isActive: boolean;
	@Output() public onClick: EventEmitter<void> = new EventEmitter<void>();
}
